import { combineReducers } from 'redux';
import getReceiptDataReducer from './getReceiptDataReducer';
import getReceiptReducer from './getReceiptReducer';
import updateReceiptReducer from './updateReceiptReducer';

const index = combineReducers({
  getReceiptData: getReceiptDataReducer,
  getReceipt: getReceiptReducer,
  updateReceipt: updateReceiptReducer,
});

export default index;
